// Loom sends a workflow's Signals and its Slack escalations as two lists. The Workflows tab reads
// them as one history, so they are merged here, oldest first. Timestamps stay as the ISO strings
// Loom sent, and the scenes format them.
const buildTimeline = (workflow) => {
  const signals = (workflow.events || []).map((event) => ({
    key: `signal-${event.signalId}`,
    type: 'SIGNAL',
    occurredAt: event.occurredAt,
    kind: event.kind,
    summary: event.summary,
    sender: event.sender,
    action: event.action,
    handledAt: event.handledAt,
  }));
  const escalations = (workflow.escalations || []).map((escalation) => ({
    key: `escalation-${escalation.id}`,
    type: 'ESCALATION',
    occurredAt: escalation.createdAt,
    reason: escalation.reason,
    summary: escalation.summary,
    message: escalation.message,
    deliveryStatus: escalation.deliveryStatus,
    decision: escalation.decision,
    decidedAt: escalation.decidedAt,
  }));

  return [...signals, ...escalations].sort((a, b) => new Date(a.occurredAt) - new Date(b.occurredAt));
};

export const adaptLoomWorkflows = (response) => {
  return (response?.workflows || []).map((workflow) => ({
    ...workflow,
    escalations: workflow.escalations || [],
    timeline: buildTimeline(workflow),
  }));
};

// Multi-select answers arrive as a list and every other answer type as one string.
export const adaptLoomIntakeSubmissions = (response) => {
  return (response?.submissions || []).map((submission) => ({
    ...submission,
    answers: (submission.answers || []).map((answer) => ({
      ...answer,
      values: Array.isArray(answer.value) ? answer.value : [answer.value].filter(Boolean),
    })),
  }));
};

export const adaptLoomCommunications = (response) => ({
  messages: response?.messages || [],
  hasMore: Boolean(response?.hasMore),
});
